export type WChanceEventItem = {
  id: number;
  name: string;
  odds: number;
  imageUrl: string;
  description: string;
  prizeType: string;
  deliveryType: string;
  startAt: string;
  endAt: string;
  hasStock: boolean;
  sort: number;
};

export type WChanceLabelStatus = {
  text: string;
  color: string;
};

export type WChanceCollectionDetailEntryItem = {
  entryId: number;
  prizeLabelName: string;
  prizeGoodsId: number;
  prizeGoodsName: string;
  status: 'pending' | 'won' | 'lost' | 'submitted';
  drawnAt: string;
  orderNum: number;
  cutoffId?: number | null;
};

export const WCHANCE_DRAW_STATUS = {
  won: { key: 'won', text: '当選', color: 'primary' },
  pending: { key: 'pending', text: '', color: '' },
  submitted: { key: 'submitted', text: '抽選待ち', color: 'black' },
  lost: { key: 'lost', text: '落選', color: 'black' },
} as const;

export type WChanceSurveyFormItem = {
  max: number;
  min: number;
  hash: string;
  type: 'email' | 'number' | 'tel' | 'text' | 'textarea' | 'url' | 'date' | 'checkbox' | 'radio';
  label: string;
  required: boolean;
  annotation?: string | null;
  placeholder?: string | null;
  value?: string | number | boolean | null;
  options?: { text: string; label: string; value: number }[];
};

export type WChanceDrawResultGoodsItem = {
  labelId?: number;
  labelName?: string;
  labelDescription?: string;
  goodsId?: number;
  goodsName?: string;
  imageUrl?: string;
  sort?: number;
  startAt?: string;
  endAt?: string;
  cutoffId?: number | null;
};

/* Wチャンス賞のくじ引き結果 */
export type LotteryDrawResultWChance = {
  id: number;
  name: string;
  wChanceType: 'manual' | 'direct' | 'batch';
  wChanceDescription: string;
  imageUrl: string;
  description: string;
  prizeType: string;
  deliveryType: string;
  startAt: string;
  endAt: string;
  hasStock: boolean;
  count: number;
  isSurveyCompleted: boolean;
  surveyUrl: string;
  surveyId: string;
};
